import React, { Suspense } from "react";
import { steps, tabs, versions } from "../../util/constants";
import { getIsEmbedded } from "../../util/params";
import { getVersion } from "../../util/getVersion";
import LoadingScreen from "../../views/LoadingScreen";
import { HotspotsTab } from "../HotspotsTab/HotspotsTab";
// import { StylesTab } from "../StylesTab/StylesTab";
import { AdvancedTab } from "../AdvancedTab/AdvancedTab";
import {
  getAdvancedTabDisabled,
  getCurrentTab,
  getHotspotsTabDisabled,
  // getStylesTabDisabled,
} from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentHotspot, setCurrentStep } from "../../redux";
import HotspotTabIcon from "remixicon-react/Focus2LineIcon";
import AdvancedTabIcon from "remixicon-react/EqualizerLineIcon";
import { TabPanel } from "../TabPanel/TabPanel";
import Tab from "../Tab/Tab";
import { tabIconSize, tabSize } from "../../config";

const SpinSpecificControls = React.lazy(() =>
  import("../SpinSpecificControls/SpinSpecificControls")
);
const StaticImageSpecificControls = React.lazy(() =>
  import("../StaticImageSpecificControls/StaticImageSpecificControls")
);

export function ControlPanel(props) {
  const { className, style } = props;
  const version = getVersion();
  const currentTab = useSelector(getCurrentTab);
  const dispatch = useDispatch();
  // const stylesTabDisabled = useSelector(getStylesTabDisabled);
  const advancedTabDisabled = useSelector(getAdvancedTabDisabled);
  const hotspotsTabDisabled = useSelector(getHotspotsTabDisabled);

  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        height: getIsEmbedded() ? "100vh" : "calc(100vh - 64px)", // 64px is Toolbar height
        ...style,
      }}
    >
      <div
        style={{
          flex: "1 1 80%",
          overflowX: "clip",
          height: "100%",
          display: "flex",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Tab
            label="Hotspots"
            onClick={(e) => dispatch(setCurrentHotspot(null))}
            active={currentTab === tabs.hotspots}
            disabled={hotspotsTabDisabled}
          >
            <HotspotTabIcon size={tabIconSize} />
          </Tab>
          {/* <Tab
              label="Styles"
              style={{ flexGrow: 1, minWidth: 0 }}
              value={tabs.styles}
              disabled={stylesTabDisabled}
              onClick={e=>dispatch(setCurrentStep(steps.pickTheme))}
            /> */}
          {version === versions.spin ? (
            <Tab
              label="Advanced"
              active={currentTab === tabs.advanced}
              disabled={advancedTabDisabled}
              onClick={(e) => dispatch(setCurrentStep(steps.advanced))}
            >
              <AdvancedTabIcon size={tabIconSize} />
            </Tab>
          ) : null}
          <Tab style={{ flexGrow: 1, width: `${tabSize}px` }}></Tab>
        </div>
        <TabPanel value={currentTab} label={tabs.hotspots}>
          <HotspotsTab />
        </TabPanel>
        {/* <TabPanel value={value} label={tabs.styles} style={{ height: "100%" }}>
          <StylesTab />
        </TabPanel> */}
        <TabPanel value={currentTab} label={tabs.advanced}>
          <AdvancedTab />
        </TabPanel>
      </div>

      <div
        style={{
          flex: "0 0 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          maxHeight: "20%",
        }}
      >
        <Suspense fallback={<LoadingScreen />}>
          {
            {
              [versions.spin]: <SpinSpecificControls />,
              [versions.image]: <StaticImageSpecificControls />,
            }[version]
          }
        </Suspense>
      </div>
    </div>
  );
}
